export default __webpack_public_path__ + "static/media/Housing-transparent.8586e714.png";